var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeftmenuIcon05On(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1321_3571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1666 34.6667C24.4971 34.6667 24.7742 34.5549 24.9978 34.3313C25.2214 34.1077 25.3333 33.8306 25.3333 33.5001C25.3333 33.1695 25.2214 32.8924 24.9978 32.6688C24.7742 32.4452 24.4971 32.3334 24.1666 32.3334C23.836 32.3334 23.5589 32.4452 23.3353 32.6688C23.1117 32.8924 22.9999 33.1695 22.9999 33.5001C22.9999 33.8306 23.1117 34.1077 23.3353 34.3313C23.5589 34.5549 23.836 34.6667 24.1666 34.6667ZM22.9999 31.1667H25.3333V25.3334H22.9999V31.1667ZM27.6666 33.5001H36.9999V31.1667H27.6666V33.5001ZM27.6666 28.8334H36.9999V26.5001H27.6666V28.8334ZM18.3333 39.3334V20.6667H41.6666V39.3334H18.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1321_3571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftmenuIcon05On);
export default __webpack_public_path__ + "static/media/leftmenu_icon05_on.ab8846d2abb31c4c40b7efe797470cf5.svg";
export { ForwardRef as ReactComponent };